import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-40fbd456"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["onSubmit"]
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "left" }, "Filter by", -1))
const _hoisted_3 = { class: "report row center" }
const _hoisted_4 = { class: "form-group" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Facilities", -1))
const _hoisted_6 = {
  class: "form-group",
  style: {"margin-top":"15px"}
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Date", -1))
const _hoisted_8 = ["value"]
const _hoisted_9 = {
  key: 0,
  class: "row"
}
const _hoisted_10 = { class: "form-group" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Start Date", -1))
const _hoisted_12 = { class: "form-group" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "End Date", -1))
const _hoisted_14 = ["disabled"]
const _hoisted_15 = {
  key: 0,
  class: "col"
}
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" Saving... ")
const _hoisted_17 = {
  key: 1,
  class: "col"
}

import { ref, watch } from "vue";
import BaseSpinner from "@/components/BaseSpinner.vue";
import "@vueform/multiselect/themes/default.scss";


export default /*#__PURE__*/_defineComponent({
  props: {
    facilityOptions: null,
    dateOptions: null,
    initialFormFields: null,
    formSubmitting: { type: Boolean }
  },
  emits: ["submit"],
  setup(__props: any, { emit }) {

const props = __props as {
  facilityOptions: Array<{
    label: string;
    value: string | null;
    disabled: boolean;
  }>;
  dateOptions: Array<{ text: string; value: string }>;
  initialFormFields: {
    selected_facilities: unknown;
    selected_date: string;
    start_date: string;
    end_date: string;
  };
  formSubmitting: boolean;
}





const localFormFields = ref({ ...props.initialFormFields });

watch(
  () => props.initialFormFields,
  (newVal) => {
    localFormFields.value = { ...newVal };
  },
  { deep: true }
);

const handleSubmit = () => {
  emit("submit", localFormFields.value);
};

return (_ctx: any,_cache: any) => {
  const _component_MultiSelect = _resolveComponent("MultiSelect")!

  return (_openBlock(), _createElementBlock("form", {
    class: "filter-row",
    onSubmit: _withModifiers(handleSubmit, ["prevent"])
  }, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createVNode(_component_MultiSelect, {
          modelValue: localFormFields.value.selected_facilities,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((localFormFields.value.selected_facilities) = $event)),
          placeholder: "All Facilities",
          searchable: true,
          mode: "tags",
          "break-tags": true,
          "close-on-select": false,
          options: __props.facilityOptions
        }, null, 8, ["modelValue", "options"])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        _withDirectives(_createElementVNode("select", {
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((localFormFields.value.selected_date) = $event)),
          class: "form-select"
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.dateOptions, (date) => {
            return (_openBlock(), _createElementBlock("option", {
              key: date.value,
              value: date.value
            }, _toDisplayString(date.text), 9, _hoisted_8))
          }), 128))
        ], 512), [
          [_vModelSelect, localFormFields.value.selected_date]
        ])
      ]),
      (localFormFields.value.selected_date == 'custom')
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _hoisted_11,
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((localFormFields.value.start_date) = $event)),
                type: "date",
                required: ""
              }, null, 512), [
                [_vModelText, localFormFields.value.start_date]
              ])
            ]),
            _createElementVNode("div", _hoisted_12, [
              _hoisted_13,
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((localFormFields.value.end_date) = $event)),
                type: "date",
                required: ""
              }, null, 512), [
                [_vModelText, localFormFields.value.end_date]
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", null, [
        _createElementVNode("button", {
          class: "btn btn-text",
          type: "submit",
          disabled: __props.formSubmitting
        }, [
          (__props.formSubmitting)
            ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                _hoisted_16,
                _createVNode(BaseSpinner)
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_17, "Save"))
        ], 8, _hoisted_14)
      ])
    ])
  ], 40, _hoisted_1))
}
}

})